import { AppMessage } from './app.message';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);
const ɵ0 = AppMessage;
export class AppModule {
}
export { ɵ0 };
